import React from 'react';
import { StyleSheet, Text, Pressable, View } from 'react-native';
import PropTypes from 'prop-types';
import Theme from 'Theme';
import LineIndicator from '../LineIndicator';
import { CachedImage } from '../CachedImage';

const noop = () => {};

const STYLE_TYPES = {
    ASSET: 'asset',
    ASSET_TOP: 'assetTop',
    SETTINGS: 'settings',
    SETTINGS_TOP: 'settingsTop',
    SETTINGS_ALT_TOP: 'settingsAltTop',
    SETTINGS_ALT_MIDDLE: 'settingsAltMiddle',
    SETTINGS_ALT_BOTTOM: 'settingsAltBottom'
};

const ITEM_TYPES = {
    TEXT: 'text',
    ICON: 'icon',
    IMAGE: 'image',
    NUMBER_TAG: 'numberTag',
    CHECKBOX: 'checkbox',
    COMPONENT: 'component'
};

// TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
// eslint-disable-next-line no-unused-vars
const CONFIG = (data) => ({
    // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
    // eslint-disable-next-line no-undef
    styleType: STYLE_TYPE.ASSET,
    leftItems: [],
    rightItems: [
        {
            type: 'text',
            value: 'drama'
        },
        {
            type: 'component',
            value: <View />
        },
        {
            type: 'icon',
            onPress: () => {},
            value: <View />
        }
    ],
    progressBar: {
        value: 0.2
    }
});

const styles = StyleSheet.create({
    programTitle: {
        fontFamily: Theme.regularFont,
        fontSize: 20,
        width: '80%',
        color: Theme.primaryTextColor
    },
    programSubtitle: {
        fontFamily: Theme.regularFont,
        fontSize: 18,
        color: Theme.secondaryTextColor,
        marginLeft: 10,
        marginBottom: 10
    },
    iconContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        width: 100,
        height: 70,
        marginRight: 20
    },
    icon: {
        width: 50,
        height: 27,
        marginStart: 18,
        marginBottom: 12
    },
    lineIndicatorHolder: {
        width: '100%',
        height: 1
    }
});

const AssetItem = ({
    iconUrl,
    // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
    // eslint-disable-next-line react/prop-types
    onPress,
    title,
    // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
    // eslint-disable-next-line no-unused-vars
    subTitle,
    // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
    // eslint-disable-next-line no-unused-vars
    progress
}) => (
    <Pressable style={{ flexDirection: 'row' }} onPress={onPress}>
        <View style={styles.iconContainer}>
            <CachedImage source={{ uri: iconUrl }} style={styles.icon} />
        </View>
        <View style={{ flex: 1 }}>
            <View style={{ flex: 1, flexDirection: 'row' }}>
                <View style={{ flex: 1 }}>
                    <Text numberOfLines={1} style={styles.programTitle}>
                        {title}
                    </Text>
                </View>
                <View style={{ flexDirection: 'row' }}>
                    <Text style={styles.programSubtitle}>Action</Text>
                    <Text style={styles.programSubtitle}>123min</Text>
                    <Text style={styles.programSubtitle}>18+</Text>
                </View>
            </View>

            <LineIndicator styles={styles.lineIndicatorHolder} progress={0} />
        </View>
    </Pressable>
);

AssetItem.defaultProps = {
    iconUrl: '',
    title: '',
    subTitle: '',
    progress: 0,
    onIconPress: noop,
    onDescriptionPress: noop
};

AssetItem.propTypes = {
    iconUrl: PropTypes.string,
    title: PropTypes.string,
    subTitle: PropTypes.string,
    progress: PropTypes.number,
    // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
    // eslint-disable-next-line react/no-unused-prop-types
    onIconPress: PropTypes.func,
    // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
    // eslint-disable-next-line react/no-unused-prop-types
    onDescriptionPress: PropTypes.func
};

export { STYLE_TYPES, ITEM_TYPES };

export default AssetItem;
